import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ListNiveauQualificationComponent } from './list-niveauQualification/list-niveauQualification.component';
import { FilterNiveauQualificationByNamePipe } from 'src/app/shared/pipes/filter-niveauQualification-by-name/filter-niveauQualification-by-name.pipe';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { NiveauQualificationModalDetailComponent } from './modal/niveauQualification-modal-detail/niveauQualification-modal-detail.component';
import { NiveauQualificationModalAjoutComponent } from './modal/niveauQualification-modal-ajout/niveauQualification-modal-ajout.component';

@NgModule({
	declarations: [
		ListNiveauQualificationComponent,
		NiveauQualificationModalDetailComponent,
		NiveauQualificationModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterNiveauQualificationByNamePipe]
})

export class NiveauQualificationModule {}
